var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_218_2132)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35,
    r: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 0C58.3305 0 74 15.6695 74 35C74 54.3305 58.3305 70 39 70C19.6695 70 4 54.3305 4 35C4 15.6695 19.6695 0 39 0ZM39 17.5C38.3657 17.5 37.7528 17.7297 37.2747 18.1467C36.7967 18.5636 36.4858 19.1396 36.3995 19.768L36.375 20.125V32.375H24.125C23.4599 32.3752 22.8197 32.6279 22.3337 33.0819C21.8478 33.536 21.5522 34.1575 21.5069 34.8211C21.4616 35.4846 21.6698 36.1406 22.0895 36.6565C22.5092 37.1725 23.1091 37.5098 23.768 37.6005L24.125 37.625H36.375V49.875C36.3752 50.5401 36.6279 51.1803 37.0819 51.6663C37.536 52.1522 38.1575 52.4478 38.8211 52.4931C39.4846 52.5384 40.1406 52.3302 40.6565 51.9105C41.1725 51.4908 41.5098 50.8909 41.6005 50.232L41.625 49.875V37.625H53.875C54.5401 37.6248 55.1803 37.3721 55.6663 36.9181C56.1522 36.464 56.4478 35.8425 56.4931 35.1789C56.5384 34.5154 56.3302 33.8594 55.9105 33.3435C55.4908 32.8275 54.8909 32.4902 54.232 32.3995L53.875 32.375H41.625V20.125C41.625 19.4288 41.3484 18.7611 40.8562 18.2688C40.3639 17.7766 39.6962 17.5 39 17.5Z",
    fill: "#7A03FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_218_2132",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_218_2132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_218_2132",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusIcon);
export default __webpack_public_path__ + "static/media/circlePlusIcon.6fa19b689900cd91339fd26d86dd278e.svg";
export { ForwardRef as ReactComponent };